import { Select, Icon, Loader } from '@pwc/pwc-deals-ui';
import { Constants } from '@pwc/pwc-deals-web-common';
import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { getReportEmbedDataByReportId } from '../../analyses/powerBiService';
import PowerBiPageIngestion from './PowerBiPageIngestion';
import './PowerBiSelectionContainer.scss';
import getPowerBiEmbedConfigurationBase from './getPowerBiEmbedConfigurationBase';
import { getIsDarkModeSelector } from '../../../common/redux/userSettings/userSettingsSlice';
import { getPowerBiTheme } from './getPowerBiTheme';

const PowerBiSelectionContainer = ({
  ingestionType,
  reportOptions,
  filteredReportOptions,
  setSelectedReportId,
  selectedReportId,
  selectedPage,
  setSelectedPage,
  projectId,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const powerBiReportContainerRef = useRef(null);
  const [currentReportId, setCurrentReportId] = useState('');
  const isDarkMode = useSelector(getIsDarkModeSelector);

  const handleReportSelectionChange = async (reportId) => {
    setCurrentReportId(reportId);
    if (reportId) {
      setIsLoading(true);
      const embeddedData = await getReportEmbedDataByReportId(
        projectId,
        reportId
      );
      const config = getPowerBiEmbedConfigurationBase({
        accessToken: embeddedData.embedToken,
        embedUrl: embeddedData.embedUrl,
        id: reportId,
        theme: getPowerBiTheme(isDarkMode),
      });
      if (powerBiReportContainerRef.current) {
        window.powerbi.embed(powerBiReportContainerRef.current, config);
      }
      setIsLoading(false);
    }
    setSelectedReportId(reportId);
  };

  switch (ingestionType) {
    case Constants.POWERBI_INGESTION_TYPES.report:
      return filteredReportOptions.length > 0 ? (
        <div className="power-bi-report-select">
          <Select
            data-testid="power-bi-select"
            basic
            options={filteredReportOptions}
            label="Report name"
            onChange={(event) => {
              handleReportSelectionChange(event.target.value);
            }}
            value={selectedReportId}
            placeholder="Select report"
            characterLimit={49}
          />
          {isLoading && <Loader dataTestId="power-bi-reports-loader" />}
          <div
            className={`${
              isLoading || !currentReportId
                ? 'hidden-power-bi-hint'
                : 'visible-power-bi-hint'
            }`}
          >
            <div className="import-hint">
              <Icon
                name="information"
                className="fill icon-yellow"
                width={16}
                data-testid="hint-icon"
              />
              <p>
                To resize the report, use the options available in Power BI.
              </p>
            </div>
          </div>
          <div
            className={`${
              isLoading || !currentReportId
                ? 'hidden-power-bi-container'
                : 'visible-power-bi-container'
            }`}
            data-testid="power-bi-report-container"
            ref={powerBiReportContainerRef}
          />
        </div>
      ) : (
        <span className="no-reports-span">
          No more Power BI Reports to ingest
        </span>
      );
    case Constants.POWERBI_INGESTION_TYPES.page:
      return (
        <PowerBiPageIngestion
          projectId={projectId}
          reportOptions={reportOptions}
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
          selectedReportId={selectedReportId}
          setSelectedReportId={setSelectedReportId}
        />
      );
    default:
      return null;
  }
};

export default PowerBiSelectionContainer;
